import { useState } from "react";
import { Mail, Phone, ChevronDown } from "lucide-react";
import { SEO } from "../components/SEO";

const team = [
  {
    name: "Dilraj Grewal",
    role: "Principal",
    bio: "Dilraj Grewal is the Principal of Sixty Finance and has been helping Australians achieve their financial goals for over 15 years. With extensive experience across home loans, investment lending, commercial finance, vehicle finance, and business lending, he is committed to delivering tailored solutions that meet each client's unique needs.\n\nKnown for his honest advice, strong industry knowledge, and client-first approach, Dilraj has built a reputation for making the lending process straightforward and stress-free. He believes that finance should be transparent, accessible, and focused on creating long-term financial success for every client.\n\nOutside of work, Dilraj enjoys reading, continually expanding his knowledge, and spending quality time with his family. His passion for learning and helping others is reflected in every client relationship he builds.",
    img: "https://customer-assets.emergentagent.com/job_trust-local-biz-2/artifacts/f9qsw8jf_ChatGPT%20Image%20Jul%2012%2C%202026%2C%2006_29_01%20PM.png",
    imgClass: "object-cover",
    imgStyle: { objectPosition: "50% 20%" },
    imgWrapClass: "bg-gradient-to-b from-sky-300 to-sky-500",
    email: "dilraj@sixtyfinance.com",
    phone: "0431 550 780",
    phoneHref: "tel:+61431550780",
  },
  {
    name: "Harjeet Kang",
    role: "Finance Broker",
    bio: "Harjeet Kang is a dedicated Finance Broker based in Adelaide with many years of experience helping individuals and businesses achieve their financial goals. He specialises in vehicle finance, personal loans, home loans, and asset finance, delivering tailored lending solutions designed to meet each client's unique financial needs.\n\nHarjeet is known for his honest advice, exceptional customer service, and client-first approach. He takes pride in making the lending process simple, transparent, and stress-free, while building long-term relationships founded on trust, integrity, and professionalism. His commitment to understanding each client's circumstances ensures they receive the right finance solution for their goals.\n\nOutside of work, Harjeet enjoys reading to continually expand his knowledge and stay up to date with industry trends. He also enjoys playing basketball and cricket, maintaining an active lifestyle and a healthy work-life balance while continuing to provide outstanding service to his clients.",
    img: "https://customer-assets.emergentagent.com/job_trust-local-biz-2/artifacts/1ib8zq42_ChatGPT%20Image%20Jul%2012%2C%202026%2C%2008_27_50%20PM.png",
    imgClass: "object-cover",
    imgStyle: { objectPosition: "50% 22%" },
    imgWrapClass: "bg-gradient-to-b from-slate-200 to-slate-300",
    email: "harjeet@sixtyfinance.com",
    phone: "0433 234 340",
    phoneHref: "tel:+61433234340",
  },
  {
    name: "Husandeep Maan",
    role: "Finance Broker",
    bio: "Husandeep Maan helps businesses and individuals secure the right funding for vehicles, equipment, and machinery. Specialising in tailored finance solutions, Maan works closely with clients to understand their goals, streamline the application process, and secure competitive rates from a wide panel of lenders. Whether you're a tradie upgrading your ute, a growing business investing in new equipment, or a company managing a fleet, Husandeep takes the stress out of financing so you can focus on what matters — running your business. Based in Melbourne, Husandeep is committed to honest advice, fast turnarounds, and building long-term client relationships.",
    img: "https://customer-assets.emergentagent.com/job_trust-local-biz-2/artifacts/4pxlhacg_WhatsApp%20Image%202026-07-12%20at%203.33.25%20PM.jpeg",
    imgClass: "object-cover",
    imgStyle: { objectPosition: "50% 25%" },
    imgWrapClass: "bg-gradient-to-b from-[#c9d6e2] to-[#a9bccd]",
    email: "husandeep@sixtyfinance.com",
    phone: "0468 420 685",
    phoneHref: "tel:+61468420685",
  },
  {
    name: "Ajay Grewal",
    role: "Finance Broker",
    bio: "Ajay Grewal is a Finance Broker at Sixty Finance, dedicated to helping clients secure tailored lending solutions for home loans, investment properties, vehicle finance, and business lending. He believes finance should be simple, transparent, and stress-free, taking the time to understand each client's goals and provide guidance every step of the way. Outside of work, Ajay enjoys staying active through boxing, strength training at the gym, and hiking, while also unwinding with video games. His approachable nature, strong work ethic, and passion for helping people achieve their financial goals make him a trusted partner throughout every stage of their finance journey.",
    img: "https://customer-assets.emergentagent.com/job_trust-local-biz-2/artifacts/bxyk9kdp_WhatsApp%20Image%202026-07-12%20at%204.53.21%20PM.jpeg",
    imgClass: "object-cover",
    imgStyle: { objectPosition: "50% 20%" },
    imgWrapClass: "bg-black",
    email: "ajay@sixtyfinance.com",
    phone: "0470 300 449",
    phoneHref: "tel:+61470300449",
  },
  {
    name: "Guru Dha",
    role: "Finance Broker",
    bio: "Guru Dha based in Sydney, dedicated to helping Australians achieve their property and financial goals through tailored lending solutions. With extensive experience in banking and finance, Guru specialises in home loans, refinancing, investment property finance, commercial lending, and asset finance. He is committed to providing honest advice, personalised service, and a smooth lending experience from application to settlement. Passionate about building long-term client relationships, Guru takes pride in delivering solutions that meet each client’s unique needs. Outside of work, he enjoys community involvement, networking, mentoring, and spending quality time with family and friends.",
    img: "https://customer-assets.emergentagent.com/job_trust-local-biz-2/artifacts/er1s787t_WhatsApp%20Image%202026-07-12%20at%2012.00.27%20PM%20%281%29.webp",
    imgClass: "object-cover",
    imgStyle: { objectPosition: "50% 18%" },
    imgWrapClass: "bg-white",
    email: "G@loanguru.info",
    phone: "0413 505 282",
    phoneHref: "tel:+61413505282",
  },
  {
    name: "Baltej Mangat",
    role: "Finance Broker",
    bio: "Baltej Singh Mangat is a dedicated finance specialist helping individuals and businesses secure tailored car loans, truck loans, and business loans. Committed to delivering fast approvals, competitive finance solutions, and exceptional customer service, Baltej makes the lending process simple and stress-free. Whether you're purchasing your next vehicle or growing your business, you can rely on professional guidance every step of the way.",
    img: "https://customer-assets.emergentagent.com/job_trust-local-biz-2/artifacts/hbyolqdo_ChatGPT%20Image%20Jul%2013%2C%202026%2C%2008_30_27%20PM.png",
    imgClass: "object-cover",
    imgStyle: { objectPosition: "50% 22%" },
    imgWrapClass: "bg-gradient-to-b from-slate-100 to-slate-200",
    email: "baltej.sixtyfinance@gmail.com",
    phone: "0456 207 080",
    phoneHref: "tel:+61456207080",
  },
  {
    name: "Kenny Aza",
    role: "Finance Broker",
    bio: "Kenny Aza believes finance is about much more than simply finding the right loan — it's about helping people achieve their goals with confidence. Whether clients are purchasing their first vehicle, expanding a business, investing in equipment, or taking the next step in their financial journey, his priority is to make the lending process simple, transparent, and stress-free. He understands that finance can often feel overwhelming, which is why he takes the time to genuinely understand each client's circumstances, explain their options clearly, and provide tailored solutions that align with their individual needs.\n\nCommitted to delivering exceptional service, Kenny works diligently behind the scenes to compare lenders, explore suitable finance options, and secure the right loan — not just the easiest one. Integrity, honesty, and transparency are at the heart of everything he does, and he believes that building lasting relationships is just as important as achieving successful finance outcomes. His goal is to ensure every client feels supported, informed, and confident from the initial conversation through to settlement and beyond.\n\nOutside of work, Kenny has a passion for football and enjoys both playing and following the game. He also values maintaining an active lifestyle through regular gym training. These interests have strengthened his discipline, commitment, and teamwork — qualities that are reflected in the personalised service he provides. When clients choose to work with Kenny, they can expect a dedicated finance professional who genuinely cares about helping them achieve their goals while delivering a seamless and positive finance experience every step of the way.",
    img: "https://customer-assets.emergentagent.com/job_trust-local-biz-2/artifacts/2jbo92wp_WhatsApp%20Image%202026-07-13%20at%208.12.45%20PM.jpeg",
    imgClass: "object-cover",
    imgStyle: { objectPosition: "50% 18%" },
    imgWrapClass: "bg-gradient-to-b from-slate-100 to-slate-200",
    email: "kenny.a@sixtyfinance.com",
    phone: "0402 741 957",
    phoneHref: "tel:+61402741957",
  },
  {
    name: "Manjinder Brar",
    role: "Finance Broker",
    bio: "Manjinder Singh Brar is an experienced Finance Broker with Sixty Finance, dedicated to helping individuals and families secure the right lending solutions to achieve their financial goals. Known for his honest advice, professionalism, and client-first approach, Manjinder has built strong relationships through trust and exceptional service.\n\nOutside of work, Manjinder is a proud father of two sons and a devoted family man who values spending quality time with loved ones. He has a keen interest in cars, is passionate about supporting the Punjabi community through local social clubs and events, and enjoys bringing people together by hosting weekend BBQs with family and friends. His approachable nature and strong community spirit make him someone people enjoy working with and being around.",
    img: "https://customer-assets-7cd3h4nn.emergentagent.net/job_trust-local-biz-2/artifacts/853y1h3k_WhatsApp%20Image%202026-07-19%20at%201.05.42%20PM.jpeg",
    imgClass: "object-contain",
    imgWrapClass: "bg-gradient-to-b from-slate-100 to-slate-200",
    email: "Manjinder@sixtyfinance.com",
    phone: "0433 060 000",
    phoneHref: "tel:+61433060000",
  },
];

const BIO_CHAR_LIMIT = 160;

function TeamCard({ m, i }) {
  const [expanded, setExpanded] = useState(false);
  const isLong = m.bio.length > BIO_CHAR_LIMIT;
  const shortBio = isLong ? m.bio.slice(0, BIO_CHAR_LIMIT).trimEnd() + "…" : m.bio;

  return (
    <article
      data-testid={`team-member-${i}`}
      className={`group rounded-2xl overflow-hidden bg-white border border-gray-100 hover:-translate-y-1 hover:shadow-xl transition-transform duration-300 fade-up fade-up-delay-${i + 1} flex flex-col`}
    >
      <div className={`relative h-72 overflow-hidden ${m.imgWrapClass || ""}`}>
        <img
          src={m.img}
          alt={m.name}
          style={m.imgStyle}
          className={`h-full w-full ${m.imgClass || "object-cover"} group-hover:scale-105 transition-transform duration-500`}
        />
        {!m.imgWrapClass && (
          <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-emerald-950/80 to-transparent" />
        )}
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="text-xs uppercase tracking-widest text-emerald-700 font-semibold">
          {m.role}
        </div>
        <h3 className="mt-1.5 text-lg font-semibold text-emerald-950">
          {m.name}
        </h3>

        <p className="mt-2 text-sm text-slate-600 leading-relaxed whitespace-pre-line">
          {expanded || !isLong ? m.bio : shortBio}
        </p>

        {isLong && (
          <button
            type="button"
            onClick={() => setExpanded((v) => !v)}
            data-testid={`team-bio-toggle-${i}`}
            className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 hover:text-emerald-500 transition-colors self-start"
          >
            {expanded ? "Read less" : "Read full bio"}
            <ChevronDown
              className={`h-3.5 w-3.5 transition-transform duration-300 ${expanded ? "rotate-180" : ""}`}
            />
          </button>
        )}

        <div className="mt-auto pt-5 flex flex-wrap items-center gap-2">
          <a
            href={`mailto:${m.email}`}
            aria-label={`Email ${m.name}`}
            data-testid={`team-email-${i}`}
            className="inline-flex items-center gap-1.5 px-3 h-9 rounded-full bg-emerald-50 text-emerald-800 text-xs font-semibold hover:bg-emerald-100 transition-colors max-w-full"
          >
            <Mail className="h-3.5 w-3.5 flex-none" />
            <span className="truncate">{m.email}</span>
          </a>
          {m.phone && (
            <a
              href={m.phoneHref}
              aria-label={`Call ${m.name}`}
              data-testid={`team-phone-${i}`}
              className="inline-flex items-center gap-1.5 px-3 h-9 rounded-full bg-emerald-900 text-white text-xs font-semibold hover:bg-emerald-800 transition-colors"
            >
              <Phone className="h-3.5 w-3.5" />
              <span className="num">{m.phone}</span>
            </a>
          )}
        </div>
      </div>
    </article>
  );
}

export default function Team() {
  return (
    <div>
      <SEO
        path="/team"
        title="Meet the Team — Finance Brokers"
        description="Meet the Sixty Finance team — finance brokers based in Melbourne, Sydney and Adelaide, servicing clients Australia-wide. Honest advice from real people."
      />
      <section className="bg-emerald-950 text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-24">
          <p className="text-xs uppercase tracking-widest text-emerald-300 font-semibold">Meet the team</p>
          <h1 className="mt-3 text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter max-w-3xl text-white">
            The <span className="text-emerald-300">humans</span> behind your loan.
          </h1>
          <p className="mt-6 max-w-2xl text-emerald-100/85 text-base md:text-lg leading-relaxed">
            Small team, big attention to detail. You’ll deal with the same
            broker from enquiry to settlement — and beyond.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 items-start">
          {team.map((m, i) => (
            <TeamCard key={m.name} m={m} i={i} />
          ))}
        </div>
      </section>
    </div>
  );
}
